import styled from "styled-components";

const SecondContainer = styled.div`
  display: flex;
`;
export default SecondContainer;
